import ChangePwdDialog from './ChangePwdDialog.vue';

export default {
  // eslint-disable-next-line
  install: function(Vue: any) {
    Vue.component('ChangePwdDialog', ChangePwdDialog);
  }
};
